"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectRealtorFiltersLayout = void 0;
var React = _interopRequireWildcard(require("react"));
var _valuationUtilsComponent = require("@cian/valuation-utils-component");
var styles = _interopRequireWildcard(require("./styles.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _MenuContainer = require("../../containers/MenuContainer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SelectRealtorFiltersLayout = props => {
  const isDesktop = (0, _valuationUtilsComponent.useIsDesktop)();
  const {
    dealTypeFilter,
    objectTypeFilter,
    offerTypeFilter
  } = props;
  if (!isDesktop) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement(_MenuContainer.MenuContainer, {
    activeIndex: 5
  }), /*#__PURE__*/React.createElement("form", {
    className: styles['form'],
    onSubmit: e => e.preventDefault()
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['filters']
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['filter'])
  }, dealTypeFilter), /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['filter'])
  }, offerTypeFilter), /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['filter'])
  }, objectTypeFilter))));
};
exports.SelectRealtorFiltersLayout = SelectRealtorFiltersLayout;
SelectRealtorFiltersLayout.displayName = 'SelectRealtorFiltersLayout';